module.exports = __webpack_public_path__ + "static/media/img42.d1431812.jpg";